import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import logo from '@/layout/components/logo.vue';
import { global_get, global_set_json, global_get_array } from '@/utils';
import bookmarkApi from '@/api/bookmark';
import { cache, config, globalData } from '@/store';
import i18n from '@/i18n';
import { useRoute, useRouter } from 'vue-router';

const __default__ = { name: 'browse-top' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();

const { t } = i18n.global;

let activeIndex = ref('');

let bookmarkTitle = computed(() => {
	return config.bookmarkShow
		? t('bookmarkManage.remove')
		: t('bookmarkManage.add');
})

let browseType = computed(() => {
	switch (config.browseType) {
		case 'flow':
			return t('browse.flow');
		case 'single':
			return t('browse.single');
		case 'double':
			return t('browse.double');
		case 'half':
			return t('browse.half');
		default:
			return t('browse.model');
	}
})

let chapterName = computed(() => {
	return global_get('chapterName');
})

async function handleSelect(key: string) {
	if (key === 'addBookmark') {
		if (config.bookmarkShow) {
			await bookmarkApi.delete_and_update(cache.bookmarkId);
			return;
		}
		
		let page = global_get('page');

		if (route.name === 'double') {
			page = page * 2 - 1;
		}

		if (route.name === 'half') {
			page = Math.ceil(page / 2);
		}

		await bookmarkApi.add_bookmark(page);

		const res = await bookmarkApi.get_bookmark();

		global_set_json('bookmarkList', res.list);

		return;
	}

	let query = {};
	let params = {};

	// 切换浏览模式 保持参数
	if (/(flow|single|double|half)/.test(key)) {
		query = route.query;
	}

	// 传参记录浏览模式
	if (key === 'chapter-list')
		Object.assign(params, { browseType: route.name });

	router.push({
		name: key,
		query,
		params,
	});
}

const __returned__ = { route, router, t, get activeIndex() { return activeIndex }, set activeIndex(v) { activeIndex = v }, get bookmarkTitle() { return bookmarkTitle }, set bookmarkTitle(v) { bookmarkTitle = v }, get browseType() { return browseType }, set browseType(v) { browseType = v }, get chapterName() { return chapterName }, set chapterName(v) { chapterName = v }, handleSelect, logo, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})